// Custom VFG components

<template>
  <div class="wrapper field-input">
    <input
      v-model="value"
      class="form-control"
      type="radio"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      @blur="triggerValidation"
    >
  </div>
</template> 

<script>
    export default {
        props: ['text'],
        name: 'fv_radio',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
            triggerValidation() {
                this.validate();
                return true
            }
        }
        ,
        data() {
            return {} 
        }
        } 
</script>

<style>

</style>
